import React from 'react'
import PropTypes from 'prop-types'

import RCRelatedNews from './RCRelatedNews/RCRelatedNews'

import './SideArticleContent.css'

const SideArticleContent = ({ article, slug }) => (
    <div className="side-article-content">
        <div className="side-article-content__content">
            <RCRelatedNews article={article} slug={slug} />
        </div>
    </div>
)

SideArticleContent.propTypes = {
    article: PropTypes.object
}

export { SideArticleContent }
